interface BacklogProps {
    zIndex: number;
    className?: string;
    onCloseBacklog: () => void;
}

export const Backlog: React.FC<BacklogProps> = ({ zIndex, onCloseBacklog, className = "" }) => {
    const onClose = (ev: React.MouseEvent) => {
        ev.stopPropagation();
        onCloseBacklog();
    };
    return (
        <div
            className={`backlog ${className}`}
            style={{ zIndex }}
            onClick={onClose}
        ></div>
    );
};
